<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9;">
      <!-- Aviso de nueva versión -->
      <div class="new-version-banner">
        <div class="new-version-banner-msg">
          <i class="fas fa-rocket new-version-banner-icon"></i>
          <span>
            <strong>A partir del 2 de noviembre</strong> Pedidos Pendientes solo estará disponible en la <strong>nueva consola</strong>.
            Empieza a usarla desde ahora para familiarizarte y que el día del cambio no te tome por sorpresa.
          </span>
        </div>
        <div class="new-version-banner-actions">
          <button
            type="button"
            class="new-version-banner-help"
            @click.stop="showHelp = !showHelp"
          >
            <i class="fas fa-question-circle mr-1"></i>
            ¿Dónde lo encuentro?
          </button>
          <a
            href="https://consola-v2.canplast.net/inicio?tool=pendingOrders"
            target="_blank"
            rel="noopener noreferrer"
            class="new-version-banner-link"
          >
            Ir a la nueva consola
            <i class="fas fa-external-link-alt ml-2"></i>
          </a>
        </div>

        <div v-if="showHelp" class="new-version-popover" @click.stop>
          <button
            type="button"
            class="new-version-popover-close"
            aria-label="Cerrar"
            @click="showHelp = false"
          >
            <i class="fas fa-times"></i>
          </button>
          <p class="new-version-popover-text">
            En la nueva consola abre el menú de herramientas con el ícono
            <i class="fas fa-th"></i> de arriba a la derecha y elige
            <strong>Pedidos pend.</strong> También puedes escribir «Pedidos» en el buscador.
          </p>
          <img
            src="img/nueva-consola-pedidos-pendientes.png"
            alt="Menú de herramientas y buscador de la nueva consola con la opción Pedidos pend. resaltada"
            class="new-version-popover-img"
          />
        </div>
      </div>

      <div
        class="card"
        style="overflow: hidden; border-radius: 16px;box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);"
      >
        <div v-if="rowsSelected" class="header-cta-container">
          <button
            @click="deselectAllRows"
            style="background-color: #E0E7FF; color: #525F7F;"
          >
            <i class="fas fa-times"></i> Eliminar selección
          </button>
          <div
            style="display: flex; align-items: center; justify-content: flex-start; gap: 12px;"
          >
            <button @click="handleSelectedItems('Rejected')">
              <i class="fas fa-times"></i> Rechazar
            </button>
            <button @click="handleSelectedItems('Authorized')">
              <i class="fas fa-check" style="margin-right: 6px;"></i> Autorizar
            </button>
          </div>
        </div>
        <div v-if="ready">
          <ag-grid-vue
            ref="agIncomingPayments"
            style="height: calc(80vh - 56px); margin: 0px !important;"
            class="ag-theme-alpine mb-5"
            v-bind="agIncomingPayments"
            @grid-ready="onGridReady"
            :suppressRowClickSelection="true"
            @selectionChanged="onSelectionChanged"
          />
        </div>

        <div v-else class="loader-cont">
          <base-loader></base-loader>
        </div>
      </div>
      <!-- TEMP para medir altura -->
    </div>

    <div v-if="modal" class="modal-main-container">
      <div class="table-modal-container">
        <button class="close-modal-button" @click="modal = false">
          <i class="fas fa-times" style="margin: 0px;"></i>
        </button>
        <span class="table-modal-title"><b>Facturas abiertas</b></span>
        <span class="table-modal-title" style="margin-top: -36px;"
          >{{ clientCode }} - {{ clientName }}</span
        >
        <ag-grid-vue
          ref="agInovices"
          style="height: 80vh; margin: 0px !important; width: 100%;"
          class="ag-theme-alpine mb-5"
          v-bind="agInovices"
          @grid-ready="onGridReady_"
        />
      </div>
    </div>
  </div>
</template>
<!--  @cell-clicked="onCellClickedIP" -->
<script>
/* eslint-disable vue/no-unused-components */
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import Formats from "@/mixins/Formats";
import BaseLoader from "@/components/BaseLoader.vue";
import AgIcon from "@/components/AgGrid/AgIcon.vue";
import CancelIncPayment from "../IncomingPayments/CancelIncPayment.vue";
import AgGrid from "@/mixins/AgGrid";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import { getAuth } from "firebase/auth";

export default {
  name: "TableIncPayments",
  mixins: [Formats, AgGrid],
  components: {
    AgGridVue,
    BaseLoader,
    AgIcon,
    CancelIncPayment,
    agDateInput: FilterDate,
  },
  data() {
    return {
      showHelp: false,
      validsEmails: [
        "darinkahernandez@canplast.com.mx",
        "dannasandoval@canplast.com.mx",
        "brendaterrazas@canplast.com.mx",
        "alfredoreyes@canplast.com.mx",
        "ofelialujan@canplast.com.mx",
        // "albertoserrano@canplast.com.mx",
      ],
      rowsSelected: null,
      user: null,
      ready: false,
      loading: false,
      gridApi: null,
      modal: false,
      clientName: null,
      clientCode: null,
      currentCardCode: null,
      agIncomingPayments: {
        columnDefs: [
          {
            colId: "checkbox",
            checkboxSelection: (params) => {
              const autorizacion = params.data["Autorizacion Pago"];
              return (
                this.validsEmails.includes(this.user.email) &&
                autorizacion !== "Autorizado" &&
                autorizacion !== "Al corriente"
              );
            },
            maxWidth: 60,
            suppressHeaderMenuButton: true,
            sortable: false,
            resizable: false,
            filter: false,
          },
          /* {
            field: "$ Factura",
            headerName: "$ Factura",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          }, */
          {
            field: "CardCode",
            headerName: "Código de cliente",
            maxWidth: 80,
            filter: "agTextColumnFilter",
            cellRenderer: (params) => {
              const link = document.createElement("a");
              link.href = "#"; // o puedes usar 'javascript:void(0)'
              link.innerText = params.value;
              link.style.color = "#F54B4A";
              link.style.textDecoration = "underline";
              link.style.fontWeight = 600;
              link.style.cursor = "pointer";
              link.addEventListener("click", (event) => {
                event.preventDefault();
                this.getOpenInvoices(params);
              });
              return link;
            },
            //   valueFormatter: ({ value }) => this.dateFormat(value),
          },
          {
            field: "CardName",
            headerName: "Cliente",
            sort: "desc",
            minWidth: 180,
            filter: "agTextColumnFilter",
            cellRenderer: (params) => {
              const link = document.createElement("a");
              link.href = "#"; // o puedes usar 'javascript:void(0)'
              link.innerText = params.value;
              link.style.color = "#F54B4A";
              link.style.textDecoration = "underline";
              link.style.fontWeight = 600;
              link.style.cursor = "pointer";
              link.addEventListener("click", (event) => {
                event.preventDefault();
                this.getOpenInvoices(params);
              });
              return link;
            },
          },
          {
            field: "PymntGroup",
            headerName: "Condición de pago",
            filter: "agTextColumnFilter",
            minWidth: 80,
          },
          {
            field: "CreditLine",
            headerName: "Línea de crédito",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Balance",
            headerName: "Balance",
            minWidth: 130,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Días Vencidos",
            headerName: "Días Vencidos",
            filter: "agTextColumnFilter",
            maxWidth: 80,
          },
          {
            field: "Autorizacion Pago",
            headerName: "Autorizacion Pago",
            sort: "desc",
            minWidth: 80,
            filter: "agTextColumnFilter",
          },
          {
            field: "DocNum",
            headerName: "# Pedido",
            sort: "desc",
            minWidth: 100,
            filter: "agTextColumnFilter",
          },
          {
            field: "Monto Pedido",
            headerName: "Monto Pedido",
            sort: "desc",
            minWidth: 100,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "DocDate",
            headerName: "Fecha de documento",
            sort: "desc",
            minWidth: 80,
            filter: "agDateColumnFilter",
            valueFormatter: ({ value }) => this.dateFormat(value),
          },
          {
            field: "$Pedidos Abiertos",
            headerName: "$ Pedidos Abiertos",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "$Entregas Abiertas",
            headerName: "$ Entregas Abiertas",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Fecha Pago",
            headerName: "Fecha Pago",
            filter: "agDateColumnFilter",
            valueFormatter: ({ value }) => this.dateFormat(value),
            minWidth: 80,
          },
          {
            field: "$ Pago",
            headerName: "$ Pago",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Ultimo Pago",
            headerName: "Último Pago",
            filter: "agNumberColumnFilter",
            minWidth: 140,
          },
          {
            field: "Agente",
            headerName: "Agente",
            sort: "desc",
            minWidth: 120,
            filter: "agTextColumnFilter",
          },
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: "fitGridWidth",
          defaultMinWidth: 100,
        },
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        rowModelType: "serverSide",
        loadingOverlayComponent: "BaseLoader",
        rowSelection: "multiple",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        rowMultiSelectWithClick: true,
        cacheQuickFilter: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
      },
      agInovices: {
        rowData: null,
        columnDefs: [
          {
            field: "Num Factura",
            headerName: "Número de Factura",
            maxWidth: 140,
            filter: "agNumberColumnFilter",
          },
          {
            field: "Dias de Vencimiento",
            headerName: "Dias de Vencimiento",
            sort: "desc",
            maxWidth: 120,
            filter: "agNumberColumnFilter",
          },
          {
            field: "Total en MXN",
            headerName: "Total en MXN",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Total Vencido",
            headerName: "Total Vencido",
            sort: "desc",
            minWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Pagado",
            headerName: "Pagado",
            sort: "desc",
            maxWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) => this.currencyFormat(value),
          },
          {
            field: "Fecha Factura",
            headerName: "Fecha Factura",
            sort: "desc",
            maxWidth: 120,
            filter: "agDateColumnFilter",
            valueFormatter: ({ value }) => this.dateFormat(value),
          },
          {
            field: "Fecha Vencimiento",
            headerName: "Fecha Vencimiento",
            sort: "desc",
            maxWidth: 120,
            filter: "agDateColumnFilter",
            valueFormatter: ({ value }) => this.dateFormat(value),
          },
          {
            field: "DocTotalFC",
            headerName: "Total M.E.",
            sort: "desc",
            maxWidth: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value }) =>
              Number(value) > 1 ? this.currencyFormat(value) : 0.0,
          },
          {
            field: "DocCur",
            headerName: "Moneda",
            sort: "desc",
            maxWidth: 100,
            filter: "agTextColumnFilter",
          },
          {
            field: "UUID Tesselar",
            headerName: "Timbrado UUID",
            sort: "desc",
            minWidth: 160,
            filter: "agTextColumnFilter",
          },
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: "fitGridWidth",
          defaultMinWidth: 100,
        },
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        rowSelection: "multiple",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        rowMultiSelectWithClick: true,
        cacheQuickFilter: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
      },
    };
  },
  created() {
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
    this.BASE_URL = process.env.VUE_APP_BASE_URL;

    this.user = getAuth().currentUser;
    this.ready = true;
  },
  mounted() {
    document.addEventListener("click", this.closeHelp);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeHelp);
  },

  methods: {
    closeHelp() {
      this.showHelp = false;
    },
    onGridReady({ api }) {
      this.gridApi = api;
      api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
    },
    onGridReady_({ api }) {
      this.gridApi_ = api;
    },
    deselectAllRows() {
      if (this.gridApi) {
        this.gridApi.deselectAll();
      }
    },
    reloadTable() {
      this.gridApi.setGridOption(
        "serverSideDatasource",
        this.getServerSideDatasource()
      );
    },
    sendEmail(pedido, toEmail, CardName){
      const toEmails = process.env.NODE_ENV === 'production' ? [toEmail] : [this.user.email];
      const wrongMsg = `Has rechazado el pedido ${pedido}, pero no se pudo enviar el correo.`;
      if (!toEmails.length) {
        return {
          successMsg: wrongMsg,
          pedido: pedido,
        };
      }
      const json = {
        "to": toEmails,
        "replyTo": this.user.email,
        "subject": `El pedido ${pedido} ha sido rechazado`,
        "email_body": `
          <b>Se ha rechazado el pedido ${pedido} de ${CardName}</b>
          <br>
          Para más información comunicate con ${this.user.displayName} </a>
        `
      };

      axios.post('/api/sg/email/send/general', json)
      .then((res) => {
        if(res.data.status_code === 202){
          return {
            successMsg: res.data.success_msg,
            pedido: pedido,
          }
        } else if(res.data.err && res.data.err.errors){
          return {
            successMsg: res.data.err.errors[0].message,
            pedido: pedido,
          }
        } else {
          return{
            successMsg: "Correo enviado al agente",
            pedido: pedido,
          }
        } 
      }).catch(() => {
        return {
          successMsg: wrongMsg,
          pedido: pedido,
        }
      })
    },
    handleSelectedItems(state) {
      this.$swal({
        title: `${state === "Rejected" ? "Rechazar" : "Autorizar"} Pedido`,
        text: `¿Estás seguro de ${
          state === "Rejected" ? "rechazar:" : "autorizar:"
        } ${this.selected.map((item) => item.DocEntry).join(", ")}?`,
        icon: "warning",
        confirmButtonText: `${state === "Rejected" ? "Rechazar" : "Autorizar"}`,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let sendEmailResults = [];
          this.selected.forEach((item) => {
            axios
              .patch(`${this.BASE_URL}/api/orders/${item.DocEntry}`, {
                U_PaymentApproval: state,
                U_PaymentApprovalUser: this.user.email,
              })
              .then(() => {
                if(state === "Rejected"){
                  sendEmailResults.push(this.sendEmail(item.DocNum, item.Email, item.CardName))
                  //show result emails sent
                }
                this.gridApi.setGridOption(
                  "serverSideDatasource",
                  this.getServerSideDatasource()
                );
              })
              .catch((err) => {
                console.error(
                  `Error actualizando orden ${item.DocEntry}:`,
                  err
                );
              });
          });
            
          this.reloadTable();
          this.$swal(
            `Los pedidos ${this.selected
              .map((item) => item.DocEntry)
              .join(", ")} han sido ${
              state === "Rejected" ? "Rechazados" : "Autorizados"
            }`
          );
          this.deselectAllRows();
        }
      });
    },
    onSelectionChanged({ api }) {
      this.selected = api.getSelectedRows();
      this.rowsSelected = this.selected.length;
    },

    getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;
          //SUBQUERY
          const subQuery = `
              SELECT *
              FROM ${this.DATABASE}."OpenMorososPendingSO"
            `;

          //FILTERS
          let filters = ``;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map(
                  (condition) => {
                    return this.formatCondition(condition, key);
                  }
                );
                const toPush =
                  "(" +
                  conditionsArray.join(" " + filterModel[key].operator + " ") +
                  ")";
                acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if (condition) {
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if (all.length) {
              filters += "WHERE " + all.join(" AND ");
            }
          }

          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;

          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${
              sortModel[0].colId
            }" ${sortModel[0].sort.toUpperCase()}`;
            if (sortModel[0].colId !== "DocNum") {
              sorting += `, "DocNum" DESC`;
            }
          } else {
            sorting = `ORDER BY "DocNum" DESC`;
          }

          //JSON PAYLOADS
          const rowDataJson = {
            query: `
                SELECT *
                FROM (${subQuery})
                ${filters}
                ${sorting}
                ${pagination}
              `,
          };
          const totalsJson = {
            query: `
                SELECT COUNT(*) AS "rowCount"
                FROM (${subQuery})
                ${filters}
              `,
          };

          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },
    getOpenInvoices(params) {
      this.modal = true;
      console.log(params.data);
      const query = `
        SELECT * FROM ${this.DATABASE}."Open_Invoices_WEB"
        WHERE "CodigoCliente" = '${params.data.CardCode}'
        `;
      axios
        .post(`${this.HANA_URL}/api/hana/freedom`, { query })
        .then((response) => {
          this.modal = true;
          this.agInovices.rowData = response.data;
          this.clientCode = response.data[0]["CodigoCliente"];
          this.clientName = response.data[0]["NombreCliente"];
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
.ag-clickable-cell {
  cursor: pointer;
}
.ag-clickable-cell:hover {
  background: #e9ecef;
}

.header-cta-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 12px 24px;
  background-color: #f6f9fc;
  color: #8898aa;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #8898aa20;
}

.header-cta-container button {
  background-color: #5d72e4;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 16px;
  border-radius: 99px;
  border: none;
  // box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.1);
  transition: all 0.3s ease;
}

.header-cta-container button:hover {
  background-color: #5164d0;
}

.fa-times {
  margin-right: 6px;
}

.loader-cont {
  height: calc(80vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-main-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 99;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 48px;
  box-sizing: border-box;
}

.table-modal-container {
  width: 70vw;
  max-width: 1350px;
  // max-width: 880px;
  height: 80vh;
  border-radius: 16px;
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.4);
  background-color: #f6f9fc;
  box-sizing: border-box;
  //   padding: 24px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.close-modal-button {
  position: absolute;
  right: 24px;
  top: 24px;
  border-radius: 99px;
  height: 30px;
  width: 30px;
  border: none;
  background-color: #f9f9f9;
  color: #8898aa;
  transition: all 0.3s ease;
}
.close-modal-button:hover {
  background-color: #5164d0;
  color: #fff;
}

.table-modal-title {
  font-weight: 400;
  font-size: 16px;
  padding: 24px;
  padding-bottom: 12px;
  color: #7d8c9d;
}

.ag-header-cell-sortable .ag-sort-order {
  display: none;
}

/* Aviso de nueva versión */
/* position: relative para pintarse sobre .header y no quedar debajo de la franja roja */
.new-version-banner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  box-sizing: border-box;
  min-height: 42px;
  margin-bottom: 14px;
  padding: 6px 18px;
  border-radius: 10px;
  border: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  box-shadow: 0px 0px 12px rgba($color: #000000, $alpha: 0.06);
  color: #525f7f;
  font-size: 14px;
  line-height: 1.4;
}

.new-version-banner-msg {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.new-version-banner-msg strong {
  color: #32325d;
  margin-right: 4px;
}

.new-version-banner-icon {
  color: #f5365c;
  font-size: 18px;
}

.new-version-banner-link {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 8px 20px;
  border-radius: 99px;
  font-size: 13px;
  font-weight: 700;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  text-decoration: none;
  box-shadow: 0px 4px 12px rgba($color: #f5365c, $alpha: 0.3);
  transition: all 0.15s ease;
}

.new-version-banner-link:hover {
  transform: translateY(-1px);
  box-shadow: 0px 6px 18px rgba($color: #f5365c, $alpha: 0.4);
  text-decoration: none;
}

.new-version-banner-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.new-version-banner-help {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #f5365c;
  white-space: nowrap;
  cursor: pointer;
}

.new-version-banner-help:hover {
  text-decoration: underline;
}

.new-version-popover {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  z-index: 1050;
  width: 480px;
  max-width: calc(100vw - 48px);
  padding: 16px 18px 14px;
  border-radius: 12px;
  border: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  background: #fff;
  box-shadow: 0px 10px 30px rgba($color: #000000, $alpha: 0.15);
  color: #525f7f;
  font-size: 13px;
  line-height: 1.5;
}

.new-version-popover::before {
  content: "";
  position: absolute;
  top: -7px;
  right: 90px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  border-top: 1px solid rgba($color: #f5365c, $alpha: 0.2);
  transform: rotate(45deg);
}

.new-version-popover-close {
  position: absolute;
  top: 8px;
  right: 10px;
  border: 0;
  background: none;
  color: #8898aa;
  font-size: 14px;
  cursor: pointer;
}

.new-version-popover-close:hover {
  color: #32325d;
}

.new-version-popover-text {
  margin: 0 22px 12px 0;
}

.new-version-popover-text strong {
  color: #32325d;
}

.new-version-popover-img {
  display: block;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
</style>
